import step1Upload from "./step1_upload.png";
import step2Processing from "./step2_processing.png";
import step3Modeling from "./step3_modeling.png";
import step4Report from "./step4_report.png";
import step5Support from "./step5_support.png";

const clinicalWork = [
  {
    title: "HowWeWorkStep1",
    img: step1Upload,
    body: "HowWeWorkText1",
  },
  {
    title: "HowWeWorkStep2",
    img: step2Processing,
    body: "HowWeWorkText2",
  },
  {
    title: "HowWeWorkStep3",
    img: step3Modeling,
    body: "HowWeWorkText3",
  },
  {
    title: "HowWeWorkStep4",
    img: step4Report,
    body: "HowWeWorkText4",
  },
  {
    title: "HowWeWorkStep5",
    img: step5Support,
    body: "HowWeWorkText5",
  },
];

const modelingWork = [
  {
    title: "ModelingStep1Title",
    img: step1Upload,
    body: "ModelingStep1Body",
  },
  {
    title: "ModelingStep2Title",
    img: step3Modeling,
    body: "ModelingStep2Body",
  },
  {
    title: "ModelingStep3Title",
    img: step4Report,
    body: "ModelingStep3Body",
  },
  {
    title: "ModelingStep4Title",
    img: step5Support,
    body: "ModelingStep4Body",
  },
];

export { clinicalWork, modelingWork };
